import { IconDiscord, IconMedium, IconTwitter } from '@components/icons';
import React, { useMemo } from 'react';
import { SocialMediaIcon, StyledLink } from './SocialMediaLink.styles';

interface SocialMediaLinkProps {
  type: 'twitter' | 'medium' | 'discord';
  className?: string;
}

const SocialMediaLink = ({ type, className }: SocialMediaLinkProps) => {
  const socialMediaType = useMemo(() => {
    switch (type) {
      case 'discord':
        return {
          url: 'https://discord.gg/s7Sxd2CfHW',
          label: 'Discord',
          icon: <IconDiscord />,
        };

      case 'twitter':
        return {
          url: 'https://twitter.com/ArchimedesFi',
          label: 'Twitter',
          icon: <IconTwitter />,
        };

      // Default is Medium
      default:
        return {
          url: 'https://archimedesfi.medium.com',
          label: 'Medium',
          icon: <IconMedium />,
        };
    }
  }, [type]);

  return (
    <StyledLink href={socialMediaType.url} target="_blank" rel="noreferrer" className={className}>
      <SocialMediaIcon className="w-6 mr-2">{socialMediaType.icon}</SocialMediaIcon>
      {socialMediaType.label}
    </StyledLink>
  );
};

export default SocialMediaLink;
